export const convertMJD = (georgian_date) => {
  const m = ((georgian_date / 86400000) + 40587);
  const m_cut = (Math.floor(m * 100000) / 100000);

  return parseFloat(m_cut).toFixed(5);
}

const MINUTES_IN_DAY = 1440;

export const mjdDifferenceInMinutes = (date1, date2) => {
  const mjdDiff = Math.abs(date2 - date1);
  let minuteDiff = 0;

  if (mjdDiff >= 1) {
    minuteDiff += Math.floor(mjdDiff) * MINUTES_IN_DAY;
  }
  minuteDiff += (mjdDiff % 1) * MINUTES_IN_DAY;

  return minuteDiff;
}

export const displayMinutes = (timeInMinutes) => {
  const h = Math.floor(timeInMinutes / 60);
  const minutes = Math.floor(timeInMinutes % 60);

  const m = minutes.toLocaleString('en',{ minimumIntegerDigits: 2 });

  return;
 /* return `${h}:${m} since update`;*/
}
